import { Button, Typography } from '@packages/ui/shared';
import { Modal } from 'react-bootstrap';

/** Line height style for modal body text. */
const bodyTextStyle = { lineHeight: 24 };

/** Props for the DeleteWorksheetModal component. */
export type DeleteWorksheetModalProps = {
    /** Whether a delete operation is currently in flight. */
    isDeleting?: boolean;

    /** Whether the modal is visible. */
    isVisible: boolean;

    /** The display name of the worksheet being deleted (reserved for future UI use). */
    worksheetTitle: string;

    /** Callback when the user cancels the deletion. */
    onCancel: () => void;

    /** Callback when the user confirms the deletion. */
    onConfirm: () => void;
};

/**
 * Confirmation modal shown before deleting a worksheet submission.
 * Warns the user that a group and completed worksheet are required for case submission.
 *
 * @param props - {@link DeleteWorksheetModalProps}
 * @returns the delete worksheet confirmation modal
 */
export function DeleteWorksheetModal({
    isVisible,
    isDeleting,
    onCancel,
    onConfirm,
    worksheetTitle: _worksheetTitle,
}: DeleteWorksheetModalProps) {
    return (
        <Modal centered onHide={onCancel} show={isVisible}>
            <Modal.Header>
                <Modal.Title>Delete Worksheet</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="d-flex">
                    <div className="d-flex flex-column">
                        <Typography color="textDarkPrimary" style={bodyTextStyle}>
                            Are you sure you want to delete this worksheet?
                        </Typography>
                        <Typography color="textDarkPrimary" style={bodyTextStyle}>
                            To submit a case, you must select a group and complete at least one corresponding worksheet
                            with all required information.
                        </Typography>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <div className="d-flex justify-content-end gap-2 ">
                    <Button onPress={onCancel} title="Cancel" variant="ghost-blue" />
                    <Button isLoading={isDeleting} onPress={onConfirm} title="Delete" variant="danger" />
                </div>
            </Modal.Footer>
        </Modal>
    );
}
